export default [
  {
    path: '/activity-20250912-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-09-30T23:59:59.000+08:00', title: '整蛊大作战' },
  },
  {
    path: '/activity-20250912-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-09-30T23:59:59.000+08:00', title: '整蛊大作战-规则说明' },
  },
]
